import React from 'react';

import { RouterProvider } from 'react-router-dom';

import { AuthProvider } from './contexts/AuthContext';

import { LanguageProvider } from './contexts/LanguageContext';

import { ThemeProvider } from './contexts/ThemeContext';

import { SidebarProvider } from './contexts/SidebarContext';

import { FABProvider } from './contexts/FABContext';

import { NotificationProvider } from './contexts/NotificationContext';

import MFAWrapper from './components/auth/MFAWrapper';

import { router } from './routes';

import { Toaster } from 'react-hot-toast';



function App() {

  return (

    <ThemeProvider>

      <LanguageProvider>

        <AuthProvider>

          <MFAWrapper>

            <NotificationProvider>

              <SidebarProvider>

                <FABProvider>

                  <RouterProvider router={router} />

                </FABProvider>

              </SidebarProvider>

            </NotificationProvider>

          </MFAWrapper>

        </AuthProvider>

        <Toaster />

      </LanguageProvider>

    </ThemeProvider>

  );

}



export default App;

